export const getNavigatorGeolocationOptions = () => {
  return {
    enableHighAccuracy: true,
    timeout: 60000,
    maximumAge: 0
  }
}
